<template>
  <pt-life-experience-pavilion-form class="pt-life-experience-pavilion-form__page" :isEdit="is_edit"></pt-life-experience-pavilion-form>
</template>

<script>
import PtLifeExperiencePavilionForm from 'cps/integral-mall-manage/pt-life-experience-pavilion/pt-life-experience-pavilion-form'
export default {
  name: 'pt-life-experience-pavilion-form__view',
  components: {
    'pt-life-experience-pavilion-form': PtLifeExperiencePavilionForm
  },
  props: {
    isEdit: {
      type: String,
      default: ''
    },
    userLogin: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
